
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as ragEV0AT0vCGkEZfjKVMRpSurcvKYxj5_45jwyBA8bo4BufgMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/rag.vue?macro=true";
import { default as aboutyx1xIFej2pw9y9lkMjDzg9jpdmiFjaO9YCGTLZHpJ8cMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/about.vue?macro=true";
import { default as indexKLxLNgDgHVEWHDo9eY8t5hMrlSFmiSY9_45spTldZzM9AMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/index.vue?macro=true";
import { default as stats_454F2qrAwGSiWNhLtJX1Rc_lUv_45MJRbVsKI8Xv9wC_45Z4Meta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/stats.vue?macro=true";
import { default as memoryMfTcNKxToux0ON0Pp3ZXapr_45tkJSrKzKnKCblG_yX1wMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/memory.vue?macro=true";
import { default as resumerLbqhuW8ZSRBw2WYHeP1BQkEM_456NEOtr_Zxs5pzjffsMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/resume.vue?macro=true";
import { default as prompt_45labVAILkjVc2KmiwGmzGPbm3tk_455c7aSPH3BLoAe9j92BAMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/prompt-lab.vue?macro=true";
import { default as indexc5_45Uz5xiLn7BHNO15VU5uxtPjASkK2W8g91D6UX_dlAMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/admin/index.vue?macro=true";
import { default as _91shareId_93u0enlf_45PCsyOs43GDT_4bGvjqjvljhKFn7QB_K_45Z4MMMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/share/[shareId].vue?macro=true";
import { default as sentry_45clientItdEg5me_45UHqvMUqINb4wk5hm9YHsWqrvISeyMyfeoUMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/debug/sentry-client.vue?macro=true";
import { default as _91sessionId_93ygs7w8pEYyGZo92soLUfUQwpmoi_jNzCso3p3E4reiUMeta } from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/session/[sessionId].vue?macro=true";
export default [
  {
    name: "rag",
    path: "/rag",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/rag.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutyx1xIFej2pw9y9lkMjDzg9jpdmiFjaO9YCGTLZHpJ8cMeta || {},
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/index.vue")
  },
  {
    name: "stats",
    path: "/stats",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/stats.vue")
  },
  {
    name: "memory",
    path: "/memory",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/memory.vue")
  },
  {
    name: "resume",
    path: "/resume",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/resume.vue")
  },
  {
    name: "prompt-lab",
    path: "/prompt-lab",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/prompt-lab.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/admin/index.vue")
  },
  {
    name: "share-shareId",
    path: "/share/:shareId()",
    meta: _91shareId_93u0enlf_45PCsyOs43GDT_4bGvjqjvljhKFn7QB_K_45Z4MMMeta || {},
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/share/[shareId].vue")
  },
  {
    name: "debug-sentry-client",
    path: "/debug/sentry-client",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/debug/sentry-client.vue")
  },
  {
    name: "session-sessionId",
    path: "/session/:sessionId()",
    component: () => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/pages/session/[sessionId].vue")
  }
]